// @flow
import React, { Component } from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import { Map, Marker, TileLayer, Popup } from "react-leaflet-universal";
import { withGlobalContext } from "../common/GlobalContext";
import axios from "axios";
import Loading from "./Loading";
import InfoWindow from "./InfoWindow";
import type { CompliantListingType } from "flow/types";

const StyledMarker = (props) => {
  return (
    <div>
      <Marker {...props}>
        {props.onClick ? (
          <Popup className={props.classes.popup}>
            {!props.activeListing ? (
              <Loading size={80} className={props.classes.loader} />
            ) : props.markerId === props.activeListing.id ? (
              <InfoWindow {...props} activeListing={props.activeListing} />
            ) : null}
          </Popup>
        ) : null}
      </Marker>
    </div>
  );
};

type MapProps = {
  classes: Object,
  className: string,
  property: Object,
  statusOverride: string,
  defaultZoom: number,
  mapTypeId: string,
  comparables: Object,
  mapProvider: Object,
  scrollWheelZoom: boolean,
  isV1: boolean,
};

type State = {
  activeMarker: number | null,
  activeListing: CompliantListingType | null,
  favorites: Array<number>,
};

class LeafletMap extends Component<MapProps, State> {
  constructor(props) {
    super(props);

    this.state = {
      activeMarker: null,
      activeListing: null,
      favorites: [],
    };
  }

  handleClick = (marker) => {
    this.setState({ activeListing: null });
    axios
      .get(`/api/info-window/${marker.id}?format=json`)
      .then(({ data: { favorites, listing } }) => {
        this.setState({
          favorites,
          activeListing: listing,
          activeMarker: marker.id,
        });
      });
  };

  render() {
    const {
      classes,
      className,
      property,
      statusOverride,
      defaultZoom,
      mapTypeId,
      comparables,
      mapProvider,
      scrollWheelZoom,
      isV1,
    } = this.props;

    const { activeListing, favorites } = this.state;
    return property.latitude && property.longitude ? (
      <div className={classNames(classes.root, className)}>
        <Map
          zoom={defaultZoom}
          center={[
            parseFloat(property.latitude),
            parseFloat(property.longitude),
          ]}
          scrollWheelZoom={scrollWheelZoom}
          style={{ width: "100%", height: "540px" }}
          maxZoom={mapProvider.maxZoom}
        >
          <TileLayer
            attribution={mapProvider.attribution}
            url={mapProvider.url}
            maxZoom={mapProvider.maxZoom}
            id={mapTypeId}
          />
          <StyledMarker
            status={statusOverride || "Target"}
            position={[
              parseFloat(property.latitude),
              parseFloat(property.longitude),
            ]}
            classes={classes}
          />
          {isV1 &&
            comparables &&
            comparables.length > 0 &&
            comparables.map(
              (comparable) =>
                comparable.latitude && comparable.longitude ? (
                  <StyledMarker
                    onClick={() => this.handleClick(comparable)}
                    markerId={comparable.id}
                    key={comparable.id}
                    status={comparable.status}
                    position={[
                      parseFloat(comparable.latitude),
                      parseFloat(comparable.longitude),
                    ]}
                    classes={classes}
                    activeListing={activeListing}
                    favorites={favorites}
                  />
                ) : null
            )}
        </Map>
      </div>
    ) : null;
  }
}

export default withStyles((theme) => ({
  root: {
    width: "100%",
    height: "540px",
    margin: "0px auto 96px",
  },
  popup: {
    borderRadius: theme.globalBorderRadius,
    boxShadow: theme.globalBoxShadow,
    overflow: "hidden",
    "& .leaflet-popup-close-button": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      top: "4px !important",
      right: "7px !important",
      width: "25px !important",
      height: "25px !important",
      color: `${theme.colors.white} !important`,
      font: "inherit !important",
      fontSize: "25px !important",
      fontWeight: "700 !important",
      padding: "4px !important",
      borderRadius: "50% !important",
      background: "#b3bac1 !important",
    },
  },
  loader: {
    margin: "16px auto",
    textAlign: "center",
  },
}))(withGlobalContext(LeafletMap));
